import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BatutaCountry } from "@app/codebase/sign-up/interfaces/batuta-country";
import { BatutaService } from "@app/codebase/sign-up/services/batuta.service";
import { CloudbedsService } from "@app/services/cloudbeds.service";
import { ModalController } from "@ionic/angular";
import moment from "moment";
import country_codes from "../../../../assets/countrycodes.json";

@Component({
  selector: "app-modal-addguest",
  templateUrl: "./modal-addguest.component.html",
  styleUrls: ["./modal-addguest.component.scss"],
})
export class ModalAddguestComponent implements OnInit {
  public countries = country_codes;
  public guestForm!: FormGroup;
  title: string;
  customAlertOptions: any = {
    header: 'Select your country'
  };
  public today = moment().format("YYYY-MM-DD");
  @Input() reservationId: any;
  constructor(private batuta: BatutaService,
    private modalCtrlr: ModalController,
    private cloudbedsService: CloudbedsService,
    private fb: FormBuilder,) {

  }

  goBack(){
    this.modalCtrlr.dismiss();
  }

  ngOnInit() {
    this.guestForm = this.fb.group({
      reservationId: [this.reservationId],
      guestFirstName : ['', [Validators.required, Validators.minLength(2)]],
      guestLastname : ['', [Validators.required, Validators.minLength(2)]],
      guestEmail : ['', [Validators.required, Validators.email]],
      guestPhone : ['', [Validators.required]],
      guestPhoneCode : ['', [Validators.required]],
      guestCountry : ['', [Validators.required]],
      // guestCheckOut : ['', [Validators.required]],
      });
  }

  addGuest(){
    let data = this.guestForm.value;
    console.log(data);
    data.guestPhone = data.guestPhone.toString();
    data.guestCountry = data.guestCountry.split(" ")[0];
    this.cloudbedsService.addGuest(data).then((res: any) => {
      console.log(res)
      this.modalCtrlr.dismiss(res);
    });

  }
}
